module.exports = __webpack_public_path__ + "img/enterprise-certification.aae19575.png";